module.exports = "/_next/static/images/vancouver-modal-7e4dae2900f5d92b1a4afd4ac1976409.png";